module.exports = __webpack_public_path__ + "media/svg/selection-points-selected-c149f2d4.svg";